import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Feed from "../../assets/feed.png";
import Parser from "html-react-parser";
import First from "../../assets/blog/1.png";
import Second from "../../assets/blog/2.png";
import Third from "../../assets/blog/3.png";
import Fourth from "../../assets/blog/4.png";
import Five from "../../assets/blog/5.png";
import Six from "../../assets/blog/6.png";
import Seven from "../../assets/blog/7.png";
import Eight from "../../assets/blog/8.png";
import Nine from "../../assets/blog/9.png";
import Ten from "../../assets/blog/10.png";

export const FeedDetails = () => {
	const state = useLocation().state.feed;
	const index = useLocation().state.index;
	const getImage = (index) => {
		let num = index % 10;

		switch (num) {
			case 1:
				return Ten;
				break;
			case 1:
				return First;
				break;

			case 2:
				return Second;
				break;
			case 3:
				return Third;
				break;
			case 4:
				return Fourth;

				break;
			case 5:
				return Five;

				break;
			case 6:
				return Six;

				break;
			case 7:
				return Seven;

				break;
			case 8:
				return Eight;
				break;
			case 9:
				return Nine;
				break;

			default:
				return Five;

				break;
		}
	};
	const createMarkup = () => {
		return { __html: state.description };
	};
	return (
		<>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					p: 4,
				}}
			>
				{/* <Box
					sx={{
						width: "80%",
						height: 150,
						borderRadius: 4,
						bgcolor: "#F8FAFC",
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						gap: 4,
						p: 2,
					}}
				>
					<Box
						component={"img"}
						src={getImage(index)}
						display={"flex"}
						justifyContent={"start"}
						alignItems={"start"}
						alignSelf={"start"}
						height={145}
						width={145}
					/>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							textAlign: "center",
							alignSelf: "center",
						}}
					>
						<Typography fontSize={42} fontWeight={600} color={"#121926"}>
							{state.title}
						</Typography>
					</Box>
				</Box> */}
			</Box>
			<Box sx={{ p: 2 }}>
				<Card
					sx={{
						width: "80%",
						mx: "auto",
						// height: 467,
						boxShadow: "0px 15px 55px 1px #E6E6E6",
						borderRadius: "12px",
					}}
				>
					<CardContent>
						<Typography
							gutterBottom
							fontWeight={700}
							fontSize={40}
							component="div"
							px={2}
							py={2}
							lineHeight={"50px"}
						>
							{state.title}
						</Typography>

						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								justifyItems: "center",
								alignItems: "center",
							}}
						></Box>

						{/* <Typography
							px={2}
							py={2}
							fontWeight={400}
							fontSize={20}
							color="text.secondary"
						>
							{state.post}
						</Typography> */}

						<Typography
							px={2}
							py={2}
							fontWeight={400}
							fontSize={20}
							color="text.secondary"
						>
							{
								<div
									dangerouslySetInnerHTML={createMarkup()}
									className="editor"
								></div>
							}
							{/* {<div>{Parser(state.description)}</div>} */}

							{/* {state.description} */}
						</Typography>
					</CardContent>
					<CardActions>
						<Button size="small">Share</Button>
						<Button size="small">Learn More</Button>
					</CardActions>
				</Card>
			</Box>
		</>
	);
};
